module.exports = __webpack_public_path__ + "static/media/advertisement32.679dc844.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/advertisement32.jpg
// module id = 106
// module chunks = 0